import { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { getUserDataFromStorage } from 'core/auth/auth-provider-config';
import { notifySessionRejected } from 'core/auth/session-rejection.service';

const UNAUTHORIZED = 401;
const ID_TOKEN_HEADER = 'X-Id-Token';

// [1] *** Request fullfilled interceptor. Add custom headers.
export const requestInterceptor = (
  config: InternalAxiosRequestConfig
): InternalAxiosRequestConfig => {
  const userData = getUserDataFromStorage();
  if (!userData) {
    return config;
  }
  // Skip Content-Type for FormData so the browser can inject the multipart boundary.
  if (!(config.data instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json';
  }
  config.headers.Authorization = `Bearer ${userData.access_token}`;
  if (userData.id_token) {
    config.headers[ID_TOKEN_HEADER] = userData.id_token;
  }
  return config;
};

// [2] *** Request failed interceptor. Identity function, to be customizable in a future.
export const requestFailedInterceptor = (error: AxiosError) => Promise.reject(error);

// [3] *** Response fulfilled interceptor. Identity function, to be customizable in a future.
export const responseInterceptor = (response: AxiosResponse) => Promise.resolve(response);

// [4] *** Response failed interceptor. Parse and process errors to customize response.
export const responseFailedInterceptor = (error: AxiosError) => {
  if (error.response?.status === UNAUTHORIZED) {
    notifySessionRejected();
  }
  return Promise.reject(error);
};
